import api from "services/api";

// Get monthly payroll report with filters
export const getMonthlyPayrollReport = async (params) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.employee_id) queryParams.append("employee_id", params.employee_id);
  if (params.month) queryParams.append("month", params.month);
  if (params.year) queryParams.append("year", params.year);

  const url = `/v1/api/payroll/monthly-report${
    queryParams.toString() ? `?${queryParams.toString()}` : ""
  }`;
  return api.get(url);
};

// Process monthly payroll
export const processMonthlyPayroll = async (payrollData) => {
  return api.post("/v1/api/payroll/process-monthly", payrollData);
};

// Update payroll transaction status
export const updatePayrollTransactionStatus = async (
  transactionId,
  statusData,
) => {
  return api.patch(
    `/v1/api/payroll-transactions/update-status/${transactionId}`,
    statusData,
  );
};
